import { z, ZodError, ZodTypeAny } from 'zod'
import { TFunction } from 'i18next'

import { IMAGE_MIN_HEIGHT, IMAGE_MAX_HEIGHT, IMAGE_MAX_WIDTH, IMAGE_MIN_WIDTH } from '../../const/validation'

export type FormValidationError = ZodError | null

export const getInsertImageSchema = (t: TFunction): ZodTypeAny =>
  z.object({
    alt: z.string().optional(),
    height: z.preprocess(
      val => (val === '' ? null : Number(val)),
      z
        .number()
        .min(IMAGE_MIN_HEIGHT, t('shell.markdown-editor.image-min-size-validation'))
        .max(IMAGE_MAX_HEIGHT, t('shell.markdown-editor.image-max-size-validation'))
        .nullable()
    ),
    width: z.preprocess(
      val => (val === '' ? null : Number(val)),
      z
        .number()
        .min(IMAGE_MIN_WIDTH, t('shell.markdown-editor.image-min-size-validation'))
        .max(IMAGE_MAX_WIDTH, t('shell.markdown-editor.image-max-size-validation'))
        .nullable()
    ),
    src: z.string().min(1, t('shell.markdown-editor.field-empty')).url(t('shell.markdown-editor.image-url-validation')),
  })
